/*
 * Peek-carousel spotlight cho .pdp-comfort--carousel (vd made-gentle).
 * Cơ chế Coterie usp2 (đo LIVE real-browser 2026-07-03, xem reports/spec-delta.md):
 * card sáng (opacity 1) khi HIỂN THỊ ≥ ~50% trong khung cuộn ngang; card bị cắt mép
 * (<50% lộ) thì mờ 0.3. → NHIỀU card có thể sáng cùng lúc, và card sáng ĐỔI theo cuộn:
 *   scroll đầu  [1,1,0.3]  ·  giữa [1,1,1]  ·  cuối [0,1,1].
 * Dùng IntersectionObserver với root = chính grid cuộn (ngưỡng 0.5) → chuẩn theo % lộ,
 * chạy tốt iOS Safari, không dựa scroll-driven CSS chưa hỗ trợ rộng. CSS lo transition 0.8s.
 * (Trước 260703 dùng nearest-index "1 đèn dời" rồi :first-child tĩnh — cả 2 SAI so mẫu.)
 */
(function () {
  function bind(grid) {
    if (grid.dataset.carouselInit) return;
    grid.dataset.carouselInit = '1';
    var cards = grid.children;
    // Ngưỡng 0.5: card lộ ≥50% trong khung grid = sáng; bị cắt mép <50% = mờ.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-active', e.intersectionRatio >= 0.5);
      });
    }, { root: grid, threshold: [0, 0.25, 0.5, 0.75, 1] });
    for (var i = 0; i < cards.length; i++) io.observe(cards[i]);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.pdp-comfort--carousel .pdp-comfort__grid').forEach(bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
